import { AbstractLayoutHandler, InjectableViewsAdapterProps, LayoutAdapter } from '@localstack/resources';

import { ReactElement, useMemo } from 'react';

import { useRoutes } from '@localstack/services';
import { PATH_PREFIX_INSTANCE } from '@localstack/constants';
import { EmulatorType } from '@localstack/types';

import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useAuthProvider } from '~/hooks/useAuthProvider';
import { useIsFreemiumHobbyCommercialMisuse } from '~/hooks/useIsFreemiumHobbyCommercialMisuse';
import { pricingRoute } from '~/util/pricing';

import { InstanceLayout, InstanceLayoutProps } from '~/layouts';

export const InstanceAdapter = ({ Component, routes, endpoint }: InjectableViewsAdapterProps): ReactElement => {
  const { goto } = useRoutes();
  const isFreemiumHobbyCommercialMisuse = useIsFreemiumHobbyCommercialMisuse();

  const PreBakedInstanceLayout = useMemo(() => {
    const Layout = (props: InstanceLayoutProps) => <InstanceLayout {...props} endpoint={endpoint} />;
    Layout.displayName = 'PreBakedInstanceLayout';
    return Layout;
  }, [endpoint]);

  return (
    <Component
      Layout={PreBakedInstanceLayout}
      routes={routes}
      clientOverrides={{ endpoint }}
      useAuthProvider={useAuthProvider}
      useFeatureFlags={useFeatureFlags}
      onFeatureUpgradeButtonClick={() => goto(pricingRoute([EmulatorType.AWS]))}
      isFreemiumHobbyCommercialMisuse={isFreemiumHobbyCommercialMisuse}
    />
  );
};

export class InstanceHandler extends AbstractLayoutHandler {
  public handle(route: string): LayoutAdapter {
    if (route.startsWith(PATH_PREFIX_INSTANCE)) {
      return InstanceAdapter;
    }
    return super.handle(route);
  }
}
